import React, { Dispatch, SetStateAction, useCallback } from 'react';
import { DrawerFooter, RegularButton } from 'fronton-react';
import { Drawer, DrawerContent, DrawerHeader } from 'fronton-react/drawer';
import { useTranslation } from 'react-i18next';
import { modalShopsList, stockInStoresModalCloseButton } from './styles';
import { StoreStockData } from './types';
import { ModalStoreItem } from './modal-store-item';

type StocksInStoresInteractiveModalProps = {
  modalVisibility: boolean;
  setModalVisibility: Dispatch<SetStateAction<boolean>>;
  shopsList: StoreStockData[];
};

export const StocksInStoresInteractiveModal: React.FC<StocksInStoresInteractiveModalProps> = ({
  shopsList,
  modalVisibility,
  setModalVisibility,
}) => {
  const { t } = useTranslation();
  const onClose = useCallback(() => {
    setModalVisibility(false);
  }, [setModalVisibility]);

  const stockActiveSorted = shopsList
    .filter(({ stockValue, storeName }) => stockValue && storeName)
    .sort((a, b) => a.storeName.localeCompare(b.storeName));
  const stockInactiveSorted = shopsList
    .filter(({ stockValue, storeName }) => !stockValue && storeName)
    .sort((a, b) => a.storeName.localeCompare(b.storeName));
  const stockItems = (stocks: StoreStockData[]) =>
    stocks.map(({ storeName, stockUnit, stockValue, address }) => (
      <ModalStoreItem
        stockUnit={stockUnit}
        stockValue={stockValue}
        storeName={storeName}
        key={storeName}
        address={address}
      />
    ));

  return (
    <div
      className=""
      data-qa="stocks-in-stores-modal"
      aria-label={t('product-info.stocks.in-stores.modal.title')}
    >
      <Drawer onClose={onClose} show={modalVisibility}>
        <DrawerHeader onClickBack={onClose} sticky title="Наличие в магазинах"></DrawerHeader>
        <DrawerContent>
          <div className={modalShopsList}>
            {stockItems(stockActiveSorted)}
            {stockItems(stockInactiveSorted)}
          </div>
        </DrawerContent>
        <DrawerFooter sticky>
          <RegularButton
            className={stockInStoresModalCloseButton}
            onClick={onClose}
            size="l"
            variant="secondary"
          >
            {t('product-info.stocks.in-stores.modal.close')}
          </RegularButton>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};
